import { render, staticRenderFns } from "./CompanyNstRules.vue?vue&type=template&id=3afa9a10&scoped=true"
import script from "./CompanyNstRules.vue?vue&type=script&lang=js"
export * from "./CompanyNstRules.vue?vue&type=script&lang=js"
import style0 from "./CompanyNstRules.vue?vue&type=style&index=0&id=3afa9a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa9a10",
  null
  
)

export default component.exports